/**
 * Writes a first-party cookie. Scopes to `.extern.com` when running on an
 * extern.com host so `www.` and `app.` share the same value; omits the domain
 * attribute otherwise (localhost, Vercel previews) so the cookie still works
 * there, just without cross-subdomain sharing.
 */
export function setCookieValue(name: string, value: string, maxAgeSeconds: number): void {
  const host = window.location.hostname;
  const domainAttr = host.endsWith('extern.com') ? '; domain=.extern.com' : '';
  const secureAttr = window.location.protocol === 'https:' ? '; Secure' : '';

  // biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API isn't implemented in Safari/Firefox and this cookie must work everywhere
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax${domainAttr}${secureAttr}`;
}
